import React, { useRef, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import { SVGIcon } from ".";

interface Props {
  name: string;
  username: string;
  useContainer?: boolean;
}
function Header(props: Props) {
  const headerRef = useRef<HTMLElement>(null);
  useEffect(() => {
    // the padding top here is just like a placeholder for my fixed header
    // (I did it this way because header does not have fixed height)
    document.body.style.paddingTop = headerRef.current?.clientHeight + "px";
  }, []);

  const hash = window.location.hash;

  return (
    <header className="header" ref={headerRef}>
      <Navbar
        expand="md"
        className={props.useContainer ? "container" : undefined}
      >
        {/* eslint-disable-next-line */}
        <a href="#" className="navbar-brand">
          <SVGIcon id="#logo" className="header__logo" />
          {props.name}
        </a>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <ul className="navbar-nav">
            <li className={hash === "" ? "nav-item active" : "nav-item"}>
              {/* eslint-disable-next-line */}
              <a className="nav-link" href="#">
                الرئيسية
              </a>
            </li>
            <li
              className={hash === "#services" ? "nav-item active" : "nav-item"}
            >
              <a href="#services" className="nav-link">
                الخدمات
              </a>
            </li>
            <li
              className={hash === "#contact" ? "nav-item active" : "nav-item"}
            >
              <a href="#contact" className="nav-link">
                اتصل بنا
              </a>
            </li>
          </ul>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
}

Header.defaultProps = {
  useContainer: true,
};

export default Header;
